import type { IconNode } from '../types';

/**
 * @name toaster
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTBWNS43QTIgMiAwIDAgMCAxNSAySDlhMiAyIDAgMCAwLTEgMy43VjEwIiAvPgogIDxwYXRoIGQ9Ik02IDEwaDEyIiAvPgogIDxwYXRoIGQ9Ik00IDdhMiAyIDAgMCAwLTIgMnYxMWEyIDIgMCAwIDAgMiAyaDE2YTIgMiAwIDAgMCAyLTJWOWEyIDIgMCAwIDAtMi0yIiAvPgogIDxjaXJjbGUgY3g9IjgiIGN5PSIxNiIgcj0iMiIgLz4KICA8cGF0aCBkPSJNMTQgMTZoNCIgLz4KICA8cGF0aCBkPSJNMTYgMTR2OCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/toaster
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const toaster: IconNode = [
  ['path', { d: 'M16 10V5.7A2 2 0 0 0 15 2H9a2 2 0 0 0-1 3.7V10', key: '108z3e' }],
  ['path', { d: 'M6 10h12', key: '1hwodj' }],
  [
    'path',
    { d: 'M4 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2', key: 'dydk02' },
  ],
  ['circle', { cx: '8', cy: '16', r: '2', key: '1acxsx' }],
  ['path', { d: 'M14 16h4', key: '2pjzk9' }],
  ['path', { d: 'M16 14v8', key: '1v58nx' }],
];

export default toaster;
